
<div class="modal-dialog modal-fullscreen">
    <div class="modal-content">
        <div class="modal-header bg-dark">
            <div>
                <div class="card-title">
                    Terms and Conditions for Import Security Filings
                </div>
            </div>
            <button type="button" class="btn-close text-bg-info" aria-label="Close" [disabled]="true" (click)="modal.dismiss('Cross click')"></button>
        </div>

        <div class="modal-body">
            <div class="card">

                <div class="card-body">
                    <p>
                        These Terms and Conditions govern your use of 721 Logistics dba J&K Fresh East's services for the preparation and submission of Import Security Filings, including but not limited to Importer Security Filing (ISF). By using our Services, the client agrees to be bound by these Terms and Conditions.
                    </p>


                    <div>
                        <table class="table table-sm">
                            <thead>
                                <tr>
                                    <th>Importer</th>
                                    <th>Shipper</th>
                                    <th>User</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let a of agreements">
                                    <td>
                                        <div>{{a.profile.importer.name}} ({{a.profile.importer.importerNumber}})</div>
                                        <div class="small text-secondary-emphasis">{{a.profile.importer.mailingAddress.address1}}</div>
                                        <div class="small text-secondary-emphasis">{{a.profile.importer.mailingAddress.city1}}, {{a.profile.importer.mailingAddress.state}}</div>
                                        <div class="small text-secondary-emphasis">{{a.profile.importer.mailingAddress.postalCode}}</div>
                                    </td>
                                    <td>
                                        <div>{{a.manufacturer.manufacturer.name}} ({{a.manufacturer.manufacturer.mid}})</div>
                                        <div class="small text-secondary-emphasis">{{a.manufacturer.manufacturer.address.address1}}</div>
                                        <div class="small text-secondary-emphasis">{{a.manufacturer.manufacturer.address.state}}</div>
                                        <div class="small text-secondary-emphasis">{{a.manufacturer.manufacturer.address.country}}</div>
                                    </td>
                                    <td>{{a.email}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div>

                        <ol class="">
                            <li>
                                <div class="title">Scope of Services:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>Client will prepare and submit Import Security Filings based on information provided by the Client.</li>
                                    <li>The Services include data entry, transmission to relevant customs authorities, and communication regarding filing status.</li>
                                    <li>721 Logistics dba J&K Fresh East does not guarantee the accuracy or completeness of information provided by the Client.</li>
                                    <li>721 Logistics dba J&K Fresh East is not responsible for customs delays, penalties, or seizures resulting from inaccurate or incomplete information provided by the Client.</li>
                                    <li>Services may also include consultation regarding ISF compliance, if included in the agreed upon package.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Client Responsibilities</div>
                                <ul class="list-group-flush mb-2">
                                    <li>
                                        <div>
                                            The Client is responsible for providing accurate and complete information required for the Import Security Filing, including but not limited to:
                                        </div>
                                        <ul class="list-group-flush mb-2">
                                            <li>Manufacturer (or supplier) name and address</li>
                                            <li>Seller (or owner) name and address</li>
                                            <li>Buyer (or owner) name and address</li>
                                            <li>Ship-to name and address</li>
                                            <li>Container stuffing location</li>
                                            <li>Consolidator (stuffer) name and address</li>
                                            <li>Importer of record number/Foreign trade zone applicant identification number</li>
                                            <li>Consignee number(s)</li>
                                            <li>Country of origin</li>
                                            <li>Harmonized Tariff Schedule number</li>
                                            <li>Container number(s)</li>
                                            <li>Bill of lading number(s)</li>
                                        </ul>
                                    </li>

                                    <li>The Client is responsible for providing information 48 hours prior to cargo loading on the US bound vessel.</li>
                                    <li>The Client is responsible for reviewing and verifying the accuracy of all filings before submission.</li>
                                    <li>The Client is responsible for maintaining accurate records of all import transactions.</li>
                                    <li>The Client is responsible for paying all applicable customs penalties, due to late filings.</li>

                                </ul>
                            </li>

                            <li>
                                <div class="title"> Fees and Payment:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>The Client agrees to pay 721 Logistics dba J&K Fresh East the fees outlined in the agreed-upon service agreement or fee schedule.</li>
                                    <li>Payment is due within 15 days.</li>
                                    <li>721 Logistics dba J&K Fresh East reserves the right to suspend or terminate Services for non-payment.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Limitation of Liability:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>721 Logistics dba J&K Fresh East shall not be liable for any indirect, incidental, consequential, or punitive damages arising from the use of our Services.</li>
                                    <li>721 Logistics dba J&K Fresh East 's liability shall be limited to the fees paid by the Client for the specific Services in question.</li>
                                    <li>721 Logistics dba J&K Fresh East is not responsible for errors or omissions caused by the Client's provided data.</li>
                                    <li>721 Logistics dba J&K Fresh East is not responsible for changes made to customs regulations after the date of filing.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Confidentiality:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>721 Logistics dba J&K Fresh East agrees to maintain the confidentiality of all Client information.</li>
                                    <li>Client information will only be used for the purpose of providing the Services.</li>
                                    <li>721 Logistics dba J&K Fresh East may disclose client information if required by law.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Termination:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>721 Logistics dba J&K Fresh East may terminate this Agreement immediately for cause, including but not limited to non-payment or violation of these Terms and Conditions.</li>
                                    <li>Upon termination, the client is still responsible for all fees accrued.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Governing Law:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>This Agreement shall be governed by and construed in accordance with the laws of the state of Pennsylvania.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Amendments:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>721 Logistics dba J&K Fresh East reserves the right to amend these Terms and Conditions at any time.</li>
                                    <li>Changes will be effective upon posting on 721 Logistics dba J&K Fresh East ISF portal or notification to the Client.</li>
                                    <li>Continued use of the Services constitutes acceptance of the amended Terms and Conditions.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Disclaimer:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>The Services provided are for data entry and transmission only. Clients are responsible for ensuring compliance with all applicable customs regulations.</li>
                                </ul>
                            </li>

                            <li>
                                <div class="title"> Hold Harmless:</div>
                                <ul class="list-group-flush mb-2">
                                    <li>
                                        The Client/User shall defend, indemnify, and hold harmless 721 Logistics LLC, its affiliates, subsidiaries, successors, and assigns, and their respective officers, directors, employees, and agents (collectively, the "Indemnified Parties"), from and against any and all claims, liabilities, damages, losses, costs, and expenses (including reasonable attorneys' fees) arising out of, or relating to, the use of 721 Logistics LLC’s ISF Portal Software (721ISF), or any claim alleging that 721ISF infringes or misappropriates any intellectual property right of a third party, or any other claim arising from the use of 721ISF, except to the extent such claim is caused solely by the negligence or willful misconduct of the Indemnified Parties.
                                    </li>
                                </ul>
                            </li>
                        </ol>

                    </div>


                </div>


            </div>
        </div>

        <div class="modal-footer">
            <div class="card-footer">
                <div class="text-center">By using our Services, you acknowledge that you have read, understood, and agree to these Terms and Conditions.</div>
                <div class="text-center">
                    <button class="btn btn-primary me-5" (click)="agree()">I Agree</button>
                    <button class="btn btn-primary" (click)="disagree()">I Do Not Agree</button>
                </div>
            </div>
        </div>
    </div>
</div>


<div>



</div>
